import { render, staticRenderFns } from "./InfoAssess.vue?vue&type=template&id=54d06041&scoped=true&"
import script from "./InfoAssess.vue?vue&type=script&lang=js&"
export * from "./InfoAssess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d06041",
  null
  
)

export default component.exports